import { render } from "./OrderFormCompanyBusinessCard.vue?vue&type=template&id=545c9f32&scoped=true&ts=true"
import script from "./OrderFormCompanyBusinessCard.vue?vue&type=script&lang=ts"
export * from "./OrderFormCompanyBusinessCard.vue?vue&type=script&lang=ts"

import "./OrderFormCompanyBusinessCard.vue?vue&type=style&index=0&id=545c9f32&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545c9f32"]])

export default __exports__